import get from 'lodash/get';
import {
    ROUTER_LOADED,
    ROUTER_LOADING,
    ROUTER_COMPONENT_LOADED,
    ROUTER_SET_SCROLL,
    ROUTER_INITIALIZE,
} from './types';

const DEFAULT_STATE = {
    routerIsInitialized: false,
    routeIsLoading: true,
    loadedRoute: '',
    loadedComponents: {},
    loginLanguageOverride: false,
    scroll: '',
};

export const ROOT_KEY = 'APP_ROUTER';

export default function RouterReducer( state = { ...DEFAULT_STATE }, action: any ) {
    let newState = state;

    switch ( action.type ) {
        case ROUTER_LOADED:
            newState = {
                ...newState,
                loadedRoute: action.payload,
                routeIsLoading: false,
            };
            break;

        case ROUTER_LOADING:
            newState = {
                ...newState,
                routeIsLoading: true,
            };
            break;

        case ROUTER_COMPONENT_LOADED:
            newState = {
                ...newState,
                loadedComponents: {
                    ...get( newState, 'loadedComponents', {} ),
                    [ action.payload ]: true,
                },
            };
            break;

        case ROUTER_SET_SCROLL:
            newState = {
                ...newState,
                scroll: action.payload,
            };
            break;

        case ROUTER_INITIALIZE:
            newState = {
                ...newState,
                routerIsInitialized: true,
            };
    }

    return newState;
}
